export default "__VITE_ASSET__4aKqaYqY__"